module.exports = __webpack_public_path__ + "img/japan-external-causes-male.e4a4139b.png";